import { NavLink } from "react-router-dom";
interface SVGBtnProps {
  link: string;
  external?: boolean;
  src: string;
}

export default function ImgLinkBtn(props : SVGBtnProps) : JSX.Element {
  if (props.external) {
    return (
      <a className="w-6" href={props.link}>
          <img src={props.src} className="transition duration-300 hover:scale-125" alt={"missingImg"}/>
      </a>
    );
  } else {
    return (
      <NavLink className="imgNavLink" to={"/" + props.link}>
          <img src={props.src} alt={"missingImg"}/>
      </NavLink>
    );
  }
}